import { render } from "./ModalRealizarAvaliacao.vue?vue&type=template&id=728e4b97"
import script from "./ModalRealizarAvaliacao.vue?vue&type=script&lang=js"
export * from "./ModalRealizarAvaliacao.vue?vue&type=script&lang=js"

import "./ModalRealizarAvaliacao.vue?vue&type=style&index=0&id=728e4b97&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__